class CustomSortByPopup extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.closeButton = this.querySelector('.custom-sort-by-popup__close-popup');
    this.overlay = document.querySelector('.underlay[data-collection-custom-sort-by-close]');
    this.resetButton = this.querySelector('.custom-sort-by-popup__reset-filters');
    this.applyFilterButton = this.querySelector('.custom-sort-by__apply-button');
    this.sortByInput = document.querySelector('input[name="sort_by"]');
    this.collectionFiltersForm = document.querySelector('collection-filters-form');

    this.applyFilterButton.addEventListener('click', () => {
      const checkedInput = this.querySelector('input:checked');
      if (!checkedInput) return;
      const sortByLink = document.querySelector(`.popout-list__option[data-value='${checkedInput.value}']`);
      sortByLink.click();
      this.setAttribute('aria-hidden', 'true');
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
    })

    this.closeButton.addEventListener('click', () => {
      this.setAttribute('aria-hidden', 'true');
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
    })

    this.overlay.addEventListener('click', () => {
      this.setAttribute('aria-hidden', 'true');
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
    })

    this.resetButton.addEventListener('click', () => {
      const checkedInput = this.querySelector('input:checked');
      if (!checkedInput) return;
      checkedInput.checked = false;
      checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.sortByInput.value = '';
      this.sortByInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.collectionFiltersForm.submitForm();
      this.setAttribute('aria-hidden', 'true');
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
    })
  }

  checkUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const params =  urlParams.get('sort_by');

    if (!params) return;

    const customSortByInput = this.querySelector(`input[name="custom-sort-by-option"][value="${params}"]`);
    customSortByInput.checked = true;
    customSortByInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  watchUrlChanges() {
    const checkUrl = this.checkUrl.bind(this);

    checkUrl();

    window.addEventListener('popstate', checkUrl);

    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function () {
      originalPushState.apply(this, arguments);
      checkUrl();
    };

    history.replaceState = function () {
      originalReplaceState.apply(this, arguments);
      checkUrl();
    };
  }

  connectedCallback() {
    this.watchUrlChanges();
  }
}

if (!customElements.get('custom-sort-by-popup')) {
  customElements.define('custom-sort-by-popup', CustomSortByPopup);
}